<script lang="ts" setup>

	import {useAvailability} from '@/store/availability.store';
	import {computed} from 'vue';
	import {useAppStore} from '@/store/app.store';
	import {useRegionStore} from '@/store/region.store';
	import SubstitutesModal from '@/components/substitute/SubstitutesModal.vue';

	const appStore = useAppStore();
	const regionStore = useRegionStore();
	const availabilityStore = useAvailability();

	const isLoggedIn = computed(() => appStore.isLoggedIn);

	const allowedToOrder = computed(() => appStore.isAllowedToOrder(regionStore.getSelectedRegionUrlName()));

	const showSubstitutes = computed(() => availabilityStore.showSubstitutes);

	const toggleSubstitutes = () => availabilityStore.toggleSubstitutes();

</script>

<template>
	<div v-if="isLoggedIn && allowedToOrder" class="catalog-overview-header__show-substitutes">
		<label class="toggle-switch">
			<svg class="icon-modal-substitute open-substitutes" height="36" width="36">
				<use xlink:href="/assets/images/build/svg-sprite.min.svg#icon-substitute"></use>
			</svg>

			{{ $t('site.products.overview.header.availability.toggleSubstitutes.title') }}

			<input :checked="showSubstitutes"
			       class="toggle-switch__checkbox"
			       type="checkbox"
			       @change="toggleSubstitutes">

			<span class="toggle-switch__icon"></span>
		</label>

		<SubstitutesModal />
	</div>
</template>
